import { render, staticRenderFns } from "./VideoEditorStep.vue?vue&type=template&id=472f3eea"
import script from "./VideoEditorStep.vue?vue&type=script&lang=js"
export * from "./VideoEditorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports